import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

interface PageLayoutCtx {
  noPadding: boolean;
  setNoPadding: (v: boolean) => void;
}

const PageLayoutContext = createContext<PageLayoutCtx>({
  noPadding: false,
  setNoPadding: () => {},
});

export function PageLayoutProvider({ children }: { children: React.ReactNode }) {
  const [noPadding, setNoPadding] = useState(false);
  // setNoPadding is a stable state setter, so the value only changes with noPadding.
  const value = useMemo(() => ({ noPadding, setNoPadding }), [noPadding]);
  return (
    <PageLayoutContext.Provider value={value}>
      {children}
    </PageLayoutContext.Provider>
  );
}

export function usePageLayout() {
  return useContext(PageLayoutContext);
}

/**
 * Call inside any page that needs full-height layout (no outer padding).
 * Automatically restores padding when the page unmounts.
 */
export function useFullPageLayout() {
  const { setNoPadding } = usePageLayout();
  useEffect(() => {
    setNoPadding(true);
    return () => setNoPadding(false);
  }, [setNoPadding]);
}
